module.exports = __webpack_public_path__ + "static/media/tutorial-04.2789c1dc.jpg";